export default "__VITE_ASSET__BiHxD447__"